import {Map, List, fromJS} from "immutable";

export function setSubmitStatus(state, cmd, status, errors = Map()) {
  return state.setIn(["cmdSubmission", cmd], Map({
    status: status,
    errors: errors
  }));  
}

export function getSubmitInfoForCommand(state, cmd) {
  // TODO: Change to "Record"
  return state.getIn(["cmdSubmission", cmd], Map({
    status: ""
  }));
}

export function getEntityCollection(state, entityName) {
  return state.getIn(["ids", entityName], List()).map(id => {
    return state.getIn(["entities", entityName, id], Map());
  })  
}

export function getEntity(state, entityName, id) {
  return state.getIn(["entities", entityName, id], Map()); 
}

export function setEntityCollection(state, entityName, rawEntities, rawResult) {
  return state.setIn(["entities", entityName], fromJS(rawEntities))
              .setIn(["ids", entityName], fromJS(rawResult));  
}

export function removeEntity(state, entityName, id) {
  let filtered_ids = state.getIn(["ids", entityName]).filter(x => x !== id);
  return state.deleteIn(["entities", entityName, id])
              .setIn(["ids", entityName], filtered_ids);
}